import { render, staticRenderFns } from "./CardsGrid.vue?vue&type=template&id=53361bb0&scoped=true"
import script from "./CardsGrid.vue?vue&type=script&lang=js"
export * from "./CardsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53361bb0",
  null
  
)

export default component.exports